import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { ChevronsDown } from "lucide-react";
 * // Use <ChevronsDown /> instead
 */
export const ChervonDoubleIcon = createSVGWrapper(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M7.293 9.707a1 1 0 0 0 1.414 0L12 6.414l3.293 3.293a1 1 0 0 0 1.414-1.414l-4-4a1 1 0 0 0-1.414 0l-4 4a1 1 0 0 0 0 1.414ZM7.293 14.293a1 1 0 0 1 1.414 0L12 17.586l3.293-3.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414Z"
    clipRule="evenodd"
  />
);
